<ng-container [ngSwitch]="question.typeConfig.type">
  <ion-row class="text" *ngSwitchCase="QuestionType.Text">
    <ion-col size="3">
      {{ getText(question.globalizationConfig, "title") }}
    </ion-col>
    <ion-col size="9" *ngIf="question.values.length > 0; else elseBlock">
      <li *ngFor="let answer of separateAnswers(question.values[0].value)">
        {{ answer }}
      </li>
    </ion-col>
    <ng-template #elseBlock>
      <ion-col size="9">
        --
      </ion-col>
    </ng-template>
  </ion-row>

    <ion-row class="text" *ngSwitchCase="QuestionType.Description">
        <ion-col size="3">
            {{ getText(question.globalizationConfig, "title") }}
        </ion-col>
        <ion-col size="9" *ngIf="question.values.length > 0; else elseBlock">
            <li *ngFor="let answer of separateAnswers(question.values[0].value)">
                {{ answer }}
            </li>
        </ion-col>
        <ng-template #elseBlock>
            <ion-col size="9">
                --
            </ion-col>
        </ng-template>
    </ion-row>

  <ng-container *ngSwitchCase="QuestionType.GroupedSlider">
    <ion-row class="slider header">
      <ion-col size="6"></ion-col>
      <ion-col *ngFor="let value of possibleValues; let vIndex = index"  size="1.2">
        <div class="numberLabel">
          {{ vIndex + 1 }}
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      class="slider body"
      *ngFor="let globConfig of question.groupedReportColumns; let vIndex = index"
    >
      <ion-col size="6" style="justify-content:start;">
        {{ globConfig }}
      </ion-col>
      <ion-col size="1.2"
        *ngFor="
          let number of Matrix[vIndex]"
      >
        {{ number }}
      </ion-col>
    </ion-row>
    <div class="legends">
      <div *ngFor="let value of possibleValues; let vIndex = index">
        <div class="numberLabel">
          {{ vIndex + 1 }}
        </div>
        {{ value }}
      </div>
    </div>
  </ng-container>
</ng-container>
